import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { OrderStatus } from "../enums";
import { IAPIOrdersGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";
import { SystemColor, SystemColorsModel } from "./SystemColorsModel";


export class OrdersGridModel {
    id: string;
    createdDate: Date;
    status: keyof typeof OrderStatus;
    contact?: ContactReferenceModel;
    oneTime: number;
    recurring: number;
    hasProducts: boolean;
    hasMemberships: boolean;
    hasServices: boolean;
    orderId: string;
    constructor(data: Partial<OrdersGridModel> = {}) {
        this.id = data.id || '';
        this.createdDate = data.createdDate || new Date();
        this.status = data.status || OrderStatus.Draft;
        this.contact = data.contact ? new ContactReferenceModel(data.contact) : undefined;
        this.oneTime = data.oneTime || 0;
        this.recurring = data.recurring || 0;
        this.hasProducts = data.hasProducts || false;
        this.hasMemberships = data.hasMemberships || false;
        this.hasServices = data.hasServices || false;
        this.orderId = data.orderId || '';
    }

    static deserializeAPIModel(data: IAPIOrdersGridModel): OrdersGridModel {
        const mappedData: Partial<OrdersGridModel> = {
            id: data.id,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
            status: data.status,
            contact: data.contact && ContactReferenceModel.deserializeAPIModel(data.contact),
            oneTime: data.oneTime,
            recurring: data.recurring,
            hasProducts: data.hasProducts,
            hasMemberships: data.hasMemberships,
            hasServices: data.hasServices,
            orderId: data.orderId,
        };

        return new OrdersGridModel(mappedData);
    }

    getColorsByStatus(): SystemColor {
        let colors = SystemColorsModel.lightGreyColors();
        switch (this.status) {
            case 'Draft':
                colors = SystemColorsModel.lightGreyColors();
                break;
            case 'Sold':
                colors = SystemColorsModel.ligthGreenColors();
                break;
        }
        return colors;
    }
}
